import { useState, type ReactNode } from 'react';

/* Tooltip de botón-icono (patrón V2 del handoff).
 * Reglas no negociables:
 *  - el `title` del botón y este texto dicen LO MISMO;
 *  - fondo --evo-tooltip-bg, oscuro en los DOS temas (capa flotante, no
 *    superficie de página) — la tinta es --evo-tooltip-fg, fija clara;
 *  - anclado a la derecha por default (estos botones viven al final de una
 *    barra); `align="left"` para botones al inicio. */

export interface WithTooltipProps {
  label: string;
  align?: 'left' | 'right' | 'center';
  children: ReactNode;
}

export function WithTooltip({ label, align = 'right', children }: WithTooltipProps) {
  const [show, setShow] = useState(false);
  return (
    <div
      style={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      <div
        role="tooltip"
        style={{
          position: 'absolute',
          top: 'calc(100% + 6px)',
          ...(align === 'right'
            ? { right: 0 }
            : align === 'left'
              ? { left: 0 }
              : { left: '50%', transform: 'translateX(-50%)' }),
          display: show ? 'inline-flex' : 'none',
          alignItems: 'center',
          height: 'var(--evo-pill-h-sm)',
          boxSizing: 'border-box',
          padding: '0 8px',
          background: 'var(--evo-tooltip-bg)',
          border: '1px solid var(--evo-stroke)',
          borderRadius: 'var(--evo-r-sm)',
          color: 'var(--evo-tooltip-fg)',
          fontFamily: 'var(--evo-font)',
          fontSize: 'var(--evo-fs-caption)',
          lineHeight: 1,
          whiteSpace: 'nowrap',
          pointerEvents: 'none',
          zIndex: 60,
        }}
      >
        {label}
      </div>
    </div>
  );
}
